import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _class, _VideoGuide, _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { withTheme } from "styled-components";
import Box from "../../../../Styled/Box";
import FadeIn from "../../../Transitions/FadeIn/FadeIn";
import Loader from "../../../Loader";
import { useKeyPress } from "../../../Hooks/useKeyPress.js";
import { RawButton } from "../../../../Styled/Button";
import Icon, { StyledIcon } from "../../../../Styled/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const VideoWrapperBox = props => {
  const {
    viewState
  } = props;
  const handleClose = () => viewState.setVideoGuideVisible("");
  useKeyPress("Escape", () => {
    handleClose();
  });
  return /*#__PURE__*/_jsxs(_StyledBox, {
    centered: true,
    onClick: e => {
      e.stopPropagation();
      handleClose();
    },
    children: [/*#__PURE__*/_jsx(Box, {
      paddedRatio: 4,
      position: "absolute",
      topRight: true,
      children: /*#__PURE__*/_jsx(RawButton, {
        onClick: handleClose.bind(null),
        children: /*#__PURE__*/_jsx(StyledIcon, {
          styledWidth: "22px",
          light: true,
          glyph: Icon.GLYPHS.closeLight
        })
      })
    }), props.children]
  });
};
VideoWrapperBox.propTypes = {
  viewState: PropTypes.object.isRequired,
  children: PropTypes.node
};
let VideoGuide = observer(_class = (_VideoGuide = class VideoGuide extends Component {
  render() {
    const backgroundOpacity = this.props.backgroundOpacity;
    const backgroundBlackOverlay = backgroundOpacity === undefined ? undefined : 1.0 - backgroundOpacity;
    return /*#__PURE__*/_jsx(FadeIn, {
      isVisible: this.props.viewState.videoGuideVisible === this.props.videoName,
      children: /*#__PURE__*/_jsx(VideoWrapperBox, {
        viewState: this.props.viewState,
        children: /*#__PURE__*/_jsxs(_StyledBox2, {
          centered: true,
          col11: true,
          styledHeight: "87%",
          backgroundImage: this.props.background,
          backgroundBlackOverlay: backgroundBlackOverlay,
          onClick: e => e.stopPropagation(),
          children: [/*#__PURE__*/_jsx(Loader, {
            message: " "
          }), /*#__PURE__*/_jsx(_StyledIframe, {
            title: this.props.videoName,
            src: this.props.videoLink,
            allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          })]
        })
      })
    });
  }
}, _defineProperty(_VideoGuide, "displayName", "VideoGuide"), _defineProperty(_VideoGuide, "propTypes", {
  viewState: PropTypes.object.isRequired,
  videoName: PropTypes.string.isRequired,
  videoLink: PropTypes.string,
  background: PropTypes.string,
  // A number between 0 and 1.0
  backgroundOpacity: PropTypes.number,
  theme: PropTypes.object,
  t: PropTypes.func
}), _VideoGuide)) || _class;
export default withTranslation()(withTheme(VideoGuide));
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        position: fixed;\n        z-index: 99999;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 0, 0, 0.75);\n      "])));
var _StyledBox2 = _styled2(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n              svg {\n                fill: #fff;\n                width: 60px;\n                height: 60px;\n                top: -30px;\n                left: -30px;\n              }\n            "])));
var _StyledIframe = _styled3("iframe").withConfig({
  displayName: "VideoGuide___StyledIframe",
  componentId: "sc-1cwtssu-0"
})(["border:none;position:absolute;top:0;left:0;width:100%;height:100%;"]);